import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const VideoModal = ({ show, handleClose, modalContent }) => {
  return (
    <Modal show={show} onHide={handleClose} dialogClassName="modal-90w" aria-labelledby="contained-modal-title-vcenter" centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{modalContent.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-embed">
        <iframe
          src={`https://www.youtube.com/embed/${modalContent.url}`}
          width='100%'
          height='400rem'
          title="YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VideoModal;
